import { useMemo } from 'preact/hooks'
import { cdnImage } from 'helpers/image-url'

function Image({ imageUrl, alt, className, imageClass, isLazy = true, isCover = true, sizes = '100vw', fetchPriority }) {
  const classImage = `${isCover ? 'object-cover object-top' : 'object-contain'} ${imageClass}`
  const customClass = `relative ${className}`

  // Callers pass either a url string or an object carrying one.
  const first = imageUrl && imageUrl.length > 0 && imageUrl.some(Boolean) ? imageUrl[0] : window.GM_STATE.shopify.defaultImage
  const url = typeof first === 'string' ? first : first?.url

  // Keyed on the scalar url, not the array: callers build a fresh [url] every render.
  const { src, srcSet } = useMemo(() => cdnImage(url) || { src: url, srcSet: undefined }, [url])

  return (
    <figure className={customClass}>
      {/* loading/sizes/srcSet are set before src: Preact assigns props in key
          order, and the browser must see them before it picks a candidate. */}
      <img
        loading={isLazy ? 'lazy' : 'eager'}
        fetchpriority={fetchPriority}
        sizes={srcSet ? sizes : undefined}
        srcSet={srcSet}
        src={src}
        className={classImage}
        alt={alt}
      />
    </figure>
  )
}

export default Image
